import BaseAPI from "./BaseAPI";
import { URLS } from "./Endpoints";
import { GenericAPI } from "./GenericAPI";

class CompanyAPI extends GenericAPI {
  /**
   * Request que busca features de empresa
   */
  static async getFeatures() {
    try {
      const response = await BaseAPI.get(`${URLS.COMPANY}/features`);
      if (response.status === 200) return response.data;
      return { error: "Erro ao buscar configurações de empresa." };
    } catch (e) {
      return this._exception(e, "Falha ao buscar configurações de empresa");
    }
  }
}

export default CompanyAPI;
